/**
 * Created by tatekim on 2017. 2. 2..
 */
(function() {
    'use strict';

    var app = angular.module('admin.register', ['gettext', 'vvCommon']);

    app.controller("RegisterController", function($scope, $http, vv, gettextCatalog) {
        var resetForm = function() {
            $scope.form = {
                email: "",
                username: "",
                password: "",
                secret: ""
            };
            $scope.passwordConfirm = "";
            if ($scope.rForm)
                $scope.rForm.$setPristine();
        };
        resetForm();


        $scope.submitRegister = function() {
            if (!$scope.rForm.$valid) {
                alert(gettextCatalog.getString('입력이 정확하지 않습니다.'));
                return false;
            }
            $http.post("/admin/relay/" + vv.getVvMetaData('hq_svc') + "/data/register.json", $scope.form).success(function (data, status, headers, config) {
                if (data) {
                    if (data.status == 'OK') {
                        alert(gettextCatalog.getString('요청했습니다.\n관리자 승인 후 접근 가능합니다.'));
                        resetForm();
                    } else if (data.status == 'UPDATED') {
                        alert(gettextCatalog.getString('요청을 업데이트 했습니다.\n관리자 승인 후 접근 가능합니다.'));
                        resetForm();
                    } else if (data.status == 'INVALID_SECRET') {
                        alert(gettextCatalog.getString('Secret Keyword가 유효하지 않습니다.'));
                    } else if (data.status == 'DEACTIVATED') {
                        alert(gettextCatalog.getString('Deactivated User. Ask to your manager. Accounts without login for 4 weeks would be deactivated'));
                    } else if (data.status == 'DUPLICATED') {
                        alert(gettextCatalog.getString('이미 등록된 사용자입니다.'));
                    }
                } else {
                    alert('??????');
                }
            }).error(function (data, status, headers, config) {
                alert(gettextCatalog.getString('요청 실패'));
            });

            return false;
        };
    });

    app.controller("SlackRegisterController", function($rootScope, $scope, $http, vv, gettextCatalog) {
        $scope.form = {
            kind: 'slack',
            secret: '',
        };

        $scope.register = function() {
            if (!$scope.slackRegisterForm.$valid) {
                alert(gettextCatalog.getString('입력이 정확하지 않습니다.'));
                return false;
            }
            $http.post("/admin/relay/" + vv.getVvMetaData('hq_svc') + "/data/register.json", $scope.form).success(function(data, status, headers, config) {
                 if (data) {
                    if (data.status == 'OK') {
                        alert(gettextCatalog.getString('요청했습니다.\n관리자 승인 후 접근 가능합니다.'));
                    } else if (data.status == 'UPDATED') {
                        alert(gettextCatalog.getString('요청을 업데이트 했습니다.\n관리자 승인 후 접근 가능합니다.'));
                    } else if (data.status == 'INVALID_SECRET') {
                        alert(gettextCatalog.getString('Secret Keyword가 유효하지 않습니다.'));
                    } else if (data.status == 'DEACTIVATED') {
                        alert(gettextCatalog.getString('Deactivated User. Ask to your manager. Accounts without login for 4 weeks would be deactivated'));
                    } else if (data.status == 'DUPLICATED') {
                        alert(gettextCatalog.getString('이미 등록된 사용자입니다.'));
                    }
                } else {
                    alert('??????');
                }
            }).error(function(data, status, headers, config) {
                alert(gettextCatalog.getString('요청 실패'));
            });
        }
    });
})();

